import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=4d5160e2&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d5160e2')) {
      api.createRecord('4d5160e2', component.options)
    } else {
      api.reload('4d5160e2', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=4d5160e2&", function () {
      api.rerender('4d5160e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dw0iCB8iJy7y/JS/offershelp.vue"
export default component.exports